<script lang="ts">
	export let fill = "#f66d6c";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 15 15">
	<g data-name="그룹 21">
		<path
			data-name="패스 17"
			d="M260.429 93.2a.359.359 0 0 1-.255-.106.363.363 0 0 1 0-.512L274.343 78.3a.359.359 0 0 1 .51 0 .363.363 0 0 1 0 .512l-14.17 14.275a.358.358 0 0 1-.254.113z"
			transform="translate(-260.013 -78.197)"
			style={`fill:${fill}`} />
	</g>
	<g data-name="그룹 22">
		<path
			data-name="패스 18"
			d="M274.651 93.142a.362.362 0 0 1-.256-.105L260.12 78.868a.361.361 0 1 1 .512-.511l14.275 14.169a.361.361 0 0 1-.256.616z"
			transform="translate(-260.013 -78.197)"
			style={`fill:${fill}`} />
	</g>
</svg>

<style lang="scss">
</style>
